/** Football match officiating — minimum hiring charges (KES). Keep in sync with backend match.py */
export const FIRST_OFFICIAL_MIN_HIRE_KES = 2000;
export const ADDITIONAL_OFFICIAL_MIN_HIRE_KES = 1000;

export const OFFICIATING_COUNT_OPTIONS = [
  {
    count: 1,
    label: "1 Official",
    summary: "Center referee only",
    icon: "fa-solid fa-user-shield",
  },
  {
    count: 2,
    label: "2 Officials",
    summary: "Referee + 1 linesman",
    icon: "fa-solid fa-flag",
  },
  {
    count: 3,
    label: "3 Officials",
    summary: "Referee + 2 linesmen",
    icon: "fa-solid fa-people-group",
  },
  {
    count: 4,
    label: "4 Officials",
    summary: "Full crew incl. 4th official",
    icon: "fa-solid fa-clipboard-list",
  },
];

export const OFFICIATING_SLOTS = [
  {
    slot: 1,
    label: "1st Official",
    role: "Center Referee",
    icon: "fa-solid fa-user-shield",
  },
  {
    slot: 2,
    label: "2nd Official",
    role: "Linesman 1",
    icon: "fa-solid fa-flag",
  },
  {
    slot: 3,
    label: "3rd Official",
    role: "Linesman 2",
    icon: "fa-solid fa-flag",
  },
  {
    slot: 4,
    label: "4th Official",
    role: "Fourth Official",
    icon: "fa-solid fa-clipboard-list",
  },
];

export function officiatingSlotMinimumKes(slotNumber) {
  if (slotNumber <= 0) return 0;
  if (slotNumber === 1) return FIRST_OFFICIAL_MIN_HIRE_KES;
  return ADDITIONAL_OFFICIAL_MIN_HIRE_KES;
}

export function officiatingMinimumCostKes(slotsRequested) {
  if (!slotsRequested || slotsRequested <= 0) return 0;
  const capped = Math.min(Number(slotsRequested), OFFICIATING_SLOTS.length);
  let total = 0;
  for (let slot = 1; slot <= capped; slot += 1) {
    total += officiatingSlotMinimumKes(slot);
  }
  return total;
}

export function formatKes(amount) {
  return `KSh ${Number(amount).toLocaleString("en-KE")}`;
}

export function activeOfficiatingSlots(count) {
  if (!count || count <= 0) return [];
  return OFFICIATING_SLOTS.slice(0, Math.min(count, OFFICIATING_SLOTS.length));
}
